import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme: { colors } }) => colors.body};
  }

  ul,
  ul li,
  ul ul li {
    margin: 0;
    padding: 0;
    text-indent: 0;
    list-style-type: none;
  }

  #root {
    display: flex;
  }

  #windy > div:last-child {
    display: none;
  }
`;

export { GlobalStyle };
